var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurantes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Restaurantes",
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.705,
    height: 164.659,
    viewBox: "0 0 164.705 164.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #418c5a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-1",
    d: "M30.9,37.749h5.78V4.216c0-2.317.651-4.224,3.254-4.2s3.254,1.953,3.222,4.263c0,12.861.1,25.722-.085,38.583a18.452,18.452,0,0,1-9.4,16.213A4.627,4.627,0,0,0,31.2,63.692q.091,44.038,0,88.094a32.056,32.056,0,0,1-.234,4.81,9.548,9.548,0,0,1-18.8.26,24.473,24.473,0,0,1-.306-4.478q0-44.532.046-89.064a4.082,4.082,0,0,0-2.232-4.087A19.031,19.031,0,0,1,.033,42.168C0,29.626.033,17.09,0,4.555,0,2.173.423,0,3.254,0S6.509,2.212,6.476,4.555V37.573h5.76V5.264c0-2.428-.117-5.207,3.183-5.207s3.3,2.636,3.254,5.122v32.55h5.78V3.78c0-2.258.976-3.853,3.365-3.782C30.018.07,30.9,1.645,30.9,3.748v34ZM6.71,44.453c.859,4.745,3.254,8.259,7.517,9.861,3.345,1.263,4.237,3.163,4.231,6.509q-.163,45.632-.072,91.264c0,2.473-.69,5.526,3.072,6.007,2.376.306,3.313-1.543,3.313-6.092q0-45.632-.046-91.264c0-3.15.7-5.109,3.983-6.32,4.361-1.627,6.86-5.148,7.739-9.965Z",
    transform: "translate(0 0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    className: "cls-1",
    d: "M236.745,79.928v74.238c0,7.739-6.788,12.679-13.4,9.763-4.035-1.783-5.9-5.064-5.9-9.47,0-14.319-.072-28.71.065-43.061a7.9,7.9,0,0,0-2.688-6.424c-2.174-2.031-4.484-4.185-5.858-6.756a20.288,20.288,0,0,1-2.382-8.813c-.228-14.247-.391-28.5,0-42.742.508-18.875,8.7-33.93,23.874-45.111C231.59.718,233.79-.018,234.694.529c1.12.651,1.953,2.734,1.953,4.2C236.777,29.792,236.745,54.857,236.745,79.928ZM230.3,9.966c-1.21,1.061-1.881,1.575-2.467,2.174A49.764,49.764,0,0,0,213,47.033c-.215,11.468-.052,22.943,0,34.411,0,13.375-1.165,11.527,8.578,21.361a8.767,8.767,0,0,1,2.232,5.591c.182,14.683.1,29.373.1,44.057,0,.963-.325,2.187.137,2.838.827,1.165,2.07,2.6,3.254,2.734.885.1,2.1-1.614,2.909-2.714.365-.488.091-1.451.091-2.206V40.544Z",
    transform: "translate(-72.043 -0.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    className: "cls-1",
    d: "M147.7,101.8A45.678,45.678,0,1,1,102.1,56.24,45.678,45.678,0,0,1,147.7,101.8Zm-45.619,39.325A39.234,39.234,0,1,0,62.8,101.863,39.234,39.234,0,0,0,102.086,141.126Z",
    transform: "translate(-19.673 -19.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    className: "cls-1",
    d: "M109.432,205.523C96.512,205.354,86,202.548,76.3,196.73c-1.953-1.185-4.2-2.46-2.6-5.207s3.742-1.718,5.773-.391c.449.293.911.566,1.38.82q25.065,13.414,50.924,1.634a51.808,51.808,0,0,0,17.293-13.1c.5-.56,1-1.119,1.471-1.7,1.471-1.8,3.189-2.76,5.207-.944,1.829,1.653,1.172,3.417-.215,5.09a60.461,60.461,0,0,1-36.566,21.531C115.283,205.119,111.515,205.3,109.432,205.523Z",
    transform: "translate(-25.542 -61.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-1",
    d: "M113.443,32c13.942.221,28.248,6.073,40.25,17.573.469.443.924.9,1.347,1.386,1.3,1.49,1.549,3.124.124,4.6s-3.059,1.3-4.6.039c-.41-.345-.775-.742-1.159-1.113-17.15-16.63-40.575-20.645-62.366-10.772l-.879.4c-1.894.846-3.658.8-4.693-1.211-1.146-2.232.078-3.69,2.018-4.647C92.075,34.043,101.187,31.954,113.443,32Z",
    transform: "translate(-28.291 -11.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    className: "cls-1",
    d: "M65.348,188.919c-1.243.794-2.6,2.356-3.7,2.174-1.217-.2-2.18-1.953-3.254-3.046,1.087-1.067,2.089-2.87,3.254-3s2.447,1.5,3.677,2.363Z",
    transform: "translate(-20.386 -64.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    className: "cls-1",
    d: "M81.046,110.278c1.08-11.533,6.509-20.138,17.027-25.384,2.1-1.054,4.055-1.074,5.129,1.3,1.028,2.291-.41,3.554-2.324,4.51-8.292,4.153-12.679,10.941-13.323,20.112-.169,2.356-.944,4.159-3.521,3.957S80.884,112.582,81.046,110.278Z",
    transform: "translate(-28.287 -29.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    className: "cls-1",
    d: "M128.488,84.985c-1.256.814-2.434,2.115-3.781,2.33a2.518,2.518,0,0,1-3.04-3.053,4.744,4.744,0,0,1,3.1-3.027c1.152-.13,2.473,1.451,3.716,2.285Z",
    transform: "translate(-42.45 -28.357)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantes);
export default __webpack_public_path__ + "static/media/Restaurantes.0513fbc70b218308555afef657227c1b.svg";
export { ForwardRef as ReactComponent };